import { z } from 'zod';
import { epochMsSchema } from './primitives.js';
/** クラークの連絡種別（患者単位）。確定済みHTMLの clerk.type と同一。 */
export const CLERK_TYPES = ['confirm', 'change', 'stop'];
export const clerkTypeSchema = z.enum(CLERK_TYPES);
/**
 * 操作の種類。要件書6-1の5ステータスに、薬剤部の「中止を確認」と、
 * 現場の依頼（2026-10）による「調製完了」「投与完了」を加えたもの。
 * undo は別APIで扱い、ここには含めない。
 */
export const ACTION_KINDS = [
    'confirm', // 調製確定（クラーク）
    'change', // 調製変更（クラーク）
    'stop', // 調製中止（クラーク）
    'pharm_start', // 調製開始（薬剤師）
    'stop_ack', // 中止を確認（薬剤師）
    'admin_start', // 投与開始（看護師）
    'pharm_done', // 調製完了（薬剤師）
    'admin_done', // 投与完了（看護師）
];
export const actionKindSchema = z.enum(ACTION_KINDS);
/**
 * 画面表示上の総合状態。確定済みHTMLの stateOf() の語彙に、調製完了（made）と投与完了（done）を足したもの。
 */
export const LIVE_STATES = [
    'idle',
    'confirm',
    'change',
    'stop',
    'start',
    'made',
    'admin',
    'done',
];
export const liveStateSchema = z.enum(LIVE_STATES);
export const clerkEventSchema = z.object({
    type: clerkTypeSchema,
    /** 変更・中止の理由。確定では空文字。 */
    reason: z.string().max(500),
    at: epochMsSchema,
    seq: z.number().int().positive(),
});
export const markEventSchema = z.object({
    at: epochMsSchema,
    seq: z.number().int().positive(),
});
//# sourceMappingURL=status.js.map